//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { EMPLOYEE_VIEW_OPTIONS } from '@account-settings/accountSettingsConstants';
import { SocialNetwork } from '@models/SocialNetwork';
import { TRACKING_ACTION } from '@tracker/trackerModel';
import { isDefined } from '@utils/filterPredicates';

/**
 * The tracking action for this event was previously an interpolated string, but now
 * that the tracking model uses enumerated values we have to map the view to the enum.
 */
export const getTrackingActionForEmployeeView = (
  view: EMPLOYEE_VIEW_OPTIONS,
) => {
  switch (view) {
    case EMPLOYEE_VIEW_OPTIONS.DEV:
      return TRACKING_ACTION.EMPLOYEE_VIEW_CHANGED_DEV;
    case EMPLOYEE_VIEW_OPTIONS.DOGFOOD:
      return TRACKING_ACTION.EMPLOYEE_VIEW_CHANGED_DOGFOOD;
    case EMPLOYEE_VIEW_OPTIONS.GAMMA:
      return TRACKING_ACTION.EMPLOYEE_VIEW_CHANGED_GAMMA;
    case EMPLOYEE_VIEW_OPTIONS.RELEASED:
      return TRACKING_ACTION.EMPLOYEE_VIEW_CHANGED_RELEASED;
    case EMPLOYEE_VIEW_OPTIONS.OPTINRELEASED:
      return TRACKING_ACTION.EMPLOYEE_VIEW_CHANGED_OPTINRELEASED;
    case EMPLOYEE_VIEW_OPTIONS.CLIENT_MODE:
      return TRACKING_ACTION.EMPLOYEE_VIEW_CHANGED_CLIENT_MODE;
  }
};

export const getSocialNetworkUsernameDisplay = (
  socialNetwork: SocialNetwork,
  username?: string,
): string => {
  if (isDefined(username)) {
    return `${socialNetwork === SocialNetwork.Facebook ? '' : '@'}${username}`;
  }

  return '';
};
